export default function showUndeployedChanges(show) {
  const alert = document.getElementById('undeployed-changes-alert');
  if (alert) {
    alert.style.display = show ? 'block' : 'none';
  }
}
